import { cloneDeep, treeMap } from '@/utils/tools'
import { Button, Dropdown, Menu, Tree } from '@arco-design/web-react'
import { IconMoreVertical } from '@arco-design/web-react/icon'
import React, {
  useState,
  forwardRef,
  useImperativeHandle,
  useRef,
  useEffect,
} from 'react'
const defaultFielaNames = {
  key: 'key',
  children: 'children',
  title: 'title',
  disabled: 'disabled',
}
export const CommonTree = forwardRef(
  (
    {
      children,
      items,
      menu,
      getMenu,
      onActive,
      checkItems,
      onCheckChange,
      checkStrictly = false, //是否取消父子节点关系
      autoExpandParent = true,
      fieldNames = defaultFielaNames,
      renderExtra,
      actionType,
      style = {},
    },
    ref
  ) => {
    const [selectedKeys, setSelectedKeys] = useState([])
    const [expanded, setExpanded] = useState([])
    const [treeData, setTreeData] = useState([])
    useEffect(() => {
      if (items) {
        const treedata = treeMap(cloneDeep(items), (item, index) => {
          return {
            ...item,
            title: getTitle(
              item,
              item[fieldNames?.title],
              getMenu ? getMenu(item) : menu
            ),
          }
        })
        setTreeData(treedata)
      } else {
        setTreeData([])
      }
      setExpanded([])
      setSelectedKeys([])
    }, [items])

    const getTitle = (itm, title, mnu) => {
      return (
        <div>
          <div>{title}</div>
          <div>
            {mnu && (
              <div>
                <Dropdown
                  position="br"
                  droplist={
                    <Menu>
                      {mnu?.map((m, midx) => (
                        <Menu.Item
                          key={'ddbot_' + midx}
                          onClick={() => {
                            // let itm = findItem(key);
                            m.onClick && m.onClick(itm)
                          }}
                          disabled={m.disabled}
                        >
                          <span style={{ color: m.color }}>{m.title}</span>
                        </Menu.Item>
                      ))}
                    </Menu>
                  }
                >
                  <Button
                    shape="circle"
                    type="text"
                    icon={<IconMoreVertical />}
                  />
                </Dropdown>
              </div>
            )}
          </div>
        </div>
      )
    }
    const expandRoot = () => {
      let newExpanded = []
      items.forEach((c) => {
        newExpanded.push(c.key)
      })
      setExpanded(Array.from(new Set([...expanded, ...newExpanded])))
    }
    const _setItemId = (item, itemIds) => {
      if (item.children && item.children.length > 0) {
        itemIds.push(item.key)
        item.children.forEach((c) => {
          _setItemId(c, itemIds)
        })
      }
    }

    const expandAll = () => {
      let newExpanded = []
      items.forEach((c) => {
        _setItemId(c, newExpanded)
      })
      setExpanded(Array.from(new Set([...expanded, ...newExpanded])))
    }
    const findItem = (key) => {
      const _findItem = (_key, _item) => {
        if (_item.key === _key) return _item
        if (!_item.children) return null
        for (let i = 0; i < _item.children.length; i++) {
          let itmF = _findItem(_key, _item.children[i])
          if (itmF) {
            return itmF
          }
        }
        return null
      }
      return _findItem(key, { key: '0', children: items })
    }

    useImperativeHandle(ref, () => ({
      expandAll,
      expandRoot,
      setSelectedKeys,
    }))
    return (
      <>
        <Tree
          style={style}
          actionOnClick={actionType}
          size="large"
          blockNode={true}
          autoExpandParent={autoExpandParent}
          checkStrictly={checkStrictly}
          checkable={!!checkItems}
          checkedKeys={checkItems}
          multiple={false}
          selectedKeys={selectedKeys}
          expandedKeys={expanded}
          onSelect={(keys, extra) => {
            setSelectedKeys(keys)
            const itm = findItem(keys[0])
            onActive && onActive(itm)
          }}
          onCheck={(keys, extra) => {
            onCheckChange && onCheckChange(keys)
          }}
          onExpand={(keys, extra) => {
            setExpanded(keys)
          }}
          fieldNames={fieldNames}
          treeData={treeData}
          renderExtra={renderExtra}
        ></Tree>
      </>
    )
  }
)
